// extracted by mini-css-extract-plugin
export var aggregationCell = "_53-p";
export var aggregationRow = "_53-o";
export var borderlessSpinnerContainer = "_53-3";
export var cardLayout = "_53-6";
export var cardLayoutNoFooter = "_53-a";
export var cardLayoutPageControl = "_53-9";
export var cardLayoutWithFooter = "_53-8";
export var closeIcon = "_53-h";
export var columnHeaderSurface = "_53-d";
export var columnHeaderSurfaceDragOverlay = "_53-x";
export var columnHeaderSurfaceResizing = "_53-u";
export var contextMenuAnchor = "_53-1";
export var draggableColumnHeader = "_53-v";
export var draggableColumnHeaderOverlay = "_53-w";
export var expandIcon = "_53-i";
export var expanded = "_53-j";
export var filterDropdown = "_53-k";
export var filterDropdownDivider = "_53-f";
export var filterDropdownHeader = "_53-n";
export var filterDropdownItem = "_53-m";
export var filterDropdownModal = "_53-l _53-k";
export var filterItem = "_53-e";
export var normalCellWithAdjustableBorder = "_53-g";
export var pinButtonContainer = "_53-q";
export var pinIcon = "_53-r";
export var pinIconActive = "_53-s";
export var spinner = "_53-0";
export var spinnerContainer = "_53-2";
export var tableContainer = "_53-4";
export var tableContentDraggingColumns = "_53-c";
export var tableContentInner = "_53-7";
export var tableContentInnerFill = "_53-b";
export var tableContentWrapper = "_53-5";
export var viewButtonContainer = "_53-t";